import image1 from '../../../assets/c_and_cpp_programming.jpeg';
import image2 from '../../../assets/cppTop.jpg';
import image3 from '../../../assets/webdevelopmentTop.png'
import image4 from '../../../assets/advancedjavaforTop.jpeg';
import image5 from '../../../assets/phpTop.jpg'
import image6 from '../../../assets/flutterforTop.jpg';
import image7 from '../../../assets/MysqlTop.jpg';


export const courses1=[
    {
        id:1,
        image: image1,
        title: "C and CPP Programming Online Course",
        para: "Ratting: 4.6 ★ (7,508 reviews)|95%",
        paragraph1: "C and CPP both are powerful general-purpose programming language. It can be used to develop software like operating systems, databases, compilers, and so on. C programming is an excellent language to learn to program for beginners.Our C tutorials will guide you to learn C programming one step at a time.",
        paragraph2: "The C and CPP Programming courses we offer are designed to help prepare you for a career in software development, system programming, embedded systems, and technical problem-solving, providing a strong foundation in one of the most fundamental.",
   
        name:'Learn about the programming language of C and CPP.',
        description:'C and C++ is one of the foundational programming languages used in the development of compilers, operating systems, and embedded systems where speed and efficiency matter.',
        heading:'About this course',
        deshead:'C++ is a leading programming language used in game development, virtual reality, real-time simulation and high-frequency trading, where efficiency and speed matter.',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Understanding  the concepts in C and CPP.',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the development industry.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-19',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-Beginner',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'19 lessons • 11 projects • 8 quizzes',
        topics: [
            {
              id: 1,
              name: "Lesson-1 Introduction to “ C ” Language",
              content: [
                'Data types',
                'Indentation',
                'If else',
                'Operators',
                'The “WHILE” Loop',
                'The “For “ Loop',
                'Nested Loop Statements',
                'The “BREAK” & “CONTINUE” Statement',
                'Switch case default & break',
                'Bitwise operators'
              ]
            },
            {
              id: 2,
              name: 'Lesson-2 Functions',
              content: [
                'Introduction to Functions',
                'Need for Functions',
                'Standard & User defined Functions',
                'What is header file',
                'How to create our own header file',
                'Difference between source file & exe file',
                'How to create exe file',
                'Defining & Calling Functions',
                'Storage Classes',
                'Automatic Storage Classes',
                'Register Storage Classes',
                'Static Storage Classes',
                'External Storage Classes',
                'Pass by Value, pass by Reference',
                'Return by value & return by address',
                'Recursive Functions'
              ]
            },
            {
              id: 3,
              name: 'Lesson-3 Pointers',
              content: [
                'Memory concept',
                'Pointers to variable',
                'Pointers to pointers',
                'Pointers with operation'
              ]
            },
            {
              id: 4,
              name: 'Lesson-4 Arrays',
              content: [
                'Introduction to Arrays',
                'Need for Arrays',
                'Arrays with pointers',
                'Arrays with functions',
                'Types of Arrays',
                'One Dimensional Arrays',
                'Two Dimensional Arrays',
                'Multi Dimensional Arrays',
              ]
            },
            {
              id: 5,
              name: 'Lesson-5 Strings',
              content: [
                'Char pointers',
                'Char array (String)',
                'Declaring & Initializing String Variables',
                'Strings with pointers',
                'Strings with functions',
                'String Functions',
                'Creation of our own string.h',
                'Array of Strings',
                '#define (preprocessing work)',
              ]
            },
            {
              id: 6,
              name: 'Lesson-6 Structures, Unions, Enum and typedef',
              content: [
                'Enum and typedef',
                'Introduction to Structures',
                'Defining Structures',
                'Struct with pointers , arrays, strings and functions',
                'Array ,strings as Structures Members',
                'Containership',
                'Union, Different between Structure & Union'
              ]
            },
            {
              id: 7,
              name: 'Lesson-7 Graphics Programming',
              content: [
                'In text Mode',
                'In Graphics Mode'
              ]
            },
            {
              id: 8,
              name: 'Lesson-8 File Operations',
              content: [
                'Introduction to files',
                'Types of Files',
                'File Pointers',
                'Opening & Closing Files',
                'Modifying & deleting Files',
                'Interacting with',
                'ext files (ex: .txt, .c, .cpp)',
                'non text files (ex: .dat, .mpg, .avi, .mp3)',
                'data base files',
                'Creating database with file operation',
                'Command Line Arguments',
              ]
            },
            {
              id: 9,
              name: 'Lesson-9 Dynamic memory allocation ( DS )',
              content: [
                'Purpose of dynamic memory allocation',
                'Malloc , calloc ,realloc and free',
                'Sorting●',
                'Recursion',
                'Lists',
                'Single linked lists',
                'Double linked lists',
                'Circular linked lists',
                'Stacks',
                'Queues',
                'Adding 2 lists',
                'Inserting a node in required position',
                'Deleting a node from required position'
              ]
            },
            {
              id: 10,
              name: 'Lesson-10 Introduction to “ C++ ” Programming',
              content: [
                'Oops',
                'Function Prototypes',
                'Comments',
                'Typecasting',
                'Void Pointers',
                'The :: operator',
                'The Const Qualifier',
                'Reference variables',
              ]
            },
            {
              id: 11,
              name: 'Lesson-11 Functions',
              content: [
                'Function Prototypes',
                'Function Overloading',
                'Default Arguments in Functions',
                'Call by value, address & reference',
                'Return by value, by address & By reference',
                'Inline Functions',
              ]
            },
            {
              id: 12,
              name: 'Lesson-12 Classes in C++',
              content: [
                'Member function',
                'Function Definition Outside The Class',
                'Classes and Constructors',
                'Destructors',
                'Copy Constructor',
                'The this Pointer',
                'New and delete Operators',
                'Using new and delete',
                'Malloc ( ) / free ( ) versus new/delete',
                'Classes, Objects and Memory',
                'Structures vs. Classes',
              ]
            },
            {
              id: 13,
              name: 'Lesson-13 Miscellaneous Class Issues',
              content: [
                'Static Class Data',
                'Static Member Functions',
                'Data Conversion',
                'Friend functions & friend Classes',
                'Data Conversion between Objects of Different Classes',
              ]
            },
            {
              id: 14,
              name: 'Lesson-14 Overloading operators',
              content: [
                'Introduction',
                'Overloading assignment operator',
                'Overloading ++, --, +, -, *, /,<,> …. & Logical operators',
                'Overloading operators between different objects',
                'Overloading << and >> (stream operators)'
              ]
            },
            {
              id: 15,
              name: 'Lesson-15 Inheritance',
              content: [
                'Constructors in Inheritance',
                'Private Inheritance',
                'Protected Inheritance',
                'Functions That Are Not inherited',
                'Virtual Function',
                'Pure virtual functions',
                'Virtual Functions in Derived Classes',
                'Virtual Functions and Constructors',
                'Destructors and virtual Destructors',
                'Virtual Base Classes',
                'Abstract class',
                'Abstract base class',
              ]
            },
            {
              id: 16,
              name: 'Lesson-16 Advanced Features',
              content: [
                'Classes Within Classes',
                'Friend Functions',
                'Friend classes',
                'Overloading << and >>.'
              ]
            },
            {
              id: 17,
              name: 'Lesson-17 AInput / Output In C++ (File operations)',
              content: [
                'Manipulators',
                'File I/O with Streams',
                'Opening and closing files',
                'Creating database with file Operation',
                'Binary I/O',
                'Elementary Database Management',
                'Interacting with',
                'Text files (ex: .txt, .c, .cpp)',
                'Non-text files (ex: .dat, .mpg, .avi, .mp3)',
                'Creating database with file operation'
              ]
            },
            {
              id: 18,
              name: 'Lesson-18 New Advanced Features',
              content: [
                'Templates',
                'Function templates',
                'Class templates',
                'Exception handling',
                'Namespaces',
                'RTTI (Runtime type information)',
                'STL (Standard Template library)',
                'Dynamic cast operator',
                'Typeid operator',
                'Typeinfo class',
              ]
            },
            {
              id: 19,
              name: 'Lesson-19 Advanced Features',
              content: [
                'Sorting',
                'Recursion',
                'Lists',
                'Single linked lists',
                'Double linked lists',
                'Circular linked lists',
                'Traversing of linked lists',
                'Stacks',
                'Queues',
                'Adding 2 lists',
                'Inserting a node in required position',
                'Deleting a node from required position',
              ]
            },
          ]
        

    },
    
    {
        id:2,

        image: image3,
            title: "Web Development Online Course",
            para: "Ratting: 4.8 ★ (7,508 reviews)|95%",
            paragraph1: "Web development encompasses a broad range of tasks from coding, to technical design, to performance of a website or application running on the internet.",
            paragraph2: "Web development is the act of building, creating and maintaining websites. The field encompasses a broad range of tasks including everything from coding, to technical design, to the performance of a website or application running on the internet. Web development consists of front-end and back-end components.",
       
        name:'Learn about Web Technology and Development',
        description:'The objective of the Web Development course is to provide participants with a deep understanding of advanced  concepts in Web development and technologies. ',
        heading:'About this course',
        deshead:'Web development course, helps you to update your Web development knowledge,deep understanding of advanced Web technology concepts and technologies. By the end of the course, participants should be able to develop  applications. And understand the way of web development work with different distributed ledger technologies. ',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Understanding the concepts of Web Developer Expert',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the Web development industry.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-18',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-Beginner',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'18 lessons • 10 projects • 6 quizzes',

        topics: [
            {
              id: 1,
              name: "Lesson-1 Introduction",
              content: [
                'Overview of Web and Internet',
                'Difference between Languages and Scripts',
                'Client side and Server side Programming',
                'What is HTML?',
                'Versions of HTML',
                'Structure Of HTML',
                'How html content is transferring data between browser and server',
                'Types of Webpages',
                'Introduction To Doctypes'
              ]
            },
            {
              id: 2,
              name: 'Lesson-2 HTML Tags',
              content: [
                'Types of tags',
                'Explanation about html, head and body tags',
                'Input controls and attributes',
                'How to divide web page with div tag',
                'Formatting Tags',
                'Link Tags',
                'How to create order list and unordered list',
                'Table tag',
                'Form tag',
                'Frame Tag',
                'How to provide Meta keywords',
                'What is Meta Description?'
              ]
            },
            {
              id: 3,
              name: 'Lesson-3 Attributes',
              content: [
                'What is an attribute?',
                'Attributes of html controls'
              ]
            },
            {
              id: 4,
              name: 'Lesson-4 Events',
              content: [
                'What is an event and how to use it?',
                'Dynamic html with events'
              ]
            },
            {
              id: 5,
              name: 'Lesson-5 Styling',
              content: [
                'What is a style object?',
                'Properties of style',
                'Applying styles to elements',
                'Changing style properties with events'
              ]
            },
            {
              id: 6,
              name: 'Lesson-6 Advanced HTML',
              content: [
                'How to embed the external plug-in in html document',
                'How can we display videos on browsers using html tags?',
                'How to embed external web pages in html page',
                'Resolving cross browser issues.',
                'What is new in HTML5?'
              ]
            },
            {
              id: 7,
              name: 'Lesson-7 CASCADING STYLE SHEETS',
              content: [
                'What is CSS?',
                'Advantages of CSS',
                'Why CSS?',
                'Syntax and Anotomy of CSS'
              ]
            },
            {
              id: 8,
              name: 'Lesson-8 Types of Stylesheets',
              content: [
                'External style sheet',
                'Internal style sheet',
                'Inline style'
              ]
            },
      
            {
              id: 9,
              name: 'Lesson-9 Types of Selectors',
              content: [
                'Global',
                'Class',
                'Id',
                'Grouped',
                'Descendant'
              ]
            },
            {
              id: 10,
              name: 'Lesson-10 Div’s & Span tags',
              content: [
                'Background',
                'background-color',
                'background-image',
                'background-repeat',
                'background-attachment',
                'background-position'
              ]
            },
            {
              id: 11,
              name: 'Lesson-11 Font',
              content: [
                'font-family',
                'color',
                'font-size',
                'font-style',
                'font-variant',
                'font-weight'
              ]
            },
            {
              id: 12,
              name: 'Lesson-12 Text',
              content: [
                'letter-spacing',
                'Word-spacing',
                'line-height',
                'text-decoration',
                'text-transform',
                'vertical-align',
              ]
            },
            {
              id: 13,
              name: 'Lesson-13 Introduction to javascript',
              content: [
                'Introduction of client side script',
                'Introduction of javascript',
                'Cross browser issues',
                'Declaration syntax of javascript',
                'Statements',
                'Comments',
                'Popup Boxes',
                'Alert',
                'Confirm',
                'Prompt',
                'Variables, Arrays and Operators',
                'Variables',
                'Operators',
                'Arithmetic',
                'Assignment',
                'Comparison',
                'Logical',
              ]
            },
            {
              id: 15,
              name: 'Lesson-14 Document object model',
              content: [
                'Functions and types',
                'Conversion functions'
              ]
            },
            {
              id: 16,
              name: 'Lesson-15 Conditional statements',
              content: [
                'if',
                'if…else',
                'if…else if…else',
                'Switch'
              ]
            },
            {
              id: 17,
              name: 'Lesson-16 Loops',
              content: [
                'while',
                'do…while',
                'for',
                'for…in Statement',
                'Break',
                'Continue'
              ]
            },
            {
              id: 18,
              name: 'Lesson-17 HTML TagsWindow object Document object Arrays',
              content: [
                'Associative Arrays',
                'Array Properties and Methods',
              ]
            },
            {
              id: 3,
              name: 'Lesson-18 Advanced JavaScript',
              content: [
                'Date object',
                'This object',
                'Event object',
                'State management',
                'Cookie',
                'Form validation',
                'Expressions',
                'Email validation',
                'Dynamic functionalities of html controls'
              ]
            },
          ]
    },
    {
        id:3,
        image: image4,
        title: "Advanced Java Online Course",
        para: "Ratting: 4.5 ★ (7,508 reviews)|95%",
        paragraph1: " The core Java part covers the fundamentals (data types, functions, operators, loops, thread, exception handling, etc.) of the Java programming language. It is used to develop general purpose applications.",
        paragraph2: "Whereas Advanced Java covers the standard concepts such as database connectivity, networking, Servlet, web-services, etc.Java has built-in security features that make it a secure platform for developing applications, such as automatic memory management and type checking.",
   

        name:'A Complete Java Programming Online Course.',
        description:'The objective of the Complete Java and Advanced java Programming course is to provide participants with a thorough understanding of Java, the smart contract in java programming language. ',
        heading:'About this course',
        deshead:' To learn Java programming language and for experienced Java developers looking to gain a deeper understanding of the language. The following Java tutorial explains the basic and advanced concepts of Java programming language and provides a firm foundation in the language that will enable you to begin developing your own projects and expanding on your knowledge. ',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Understanding the concepts of a complete  Java and Adavanced Java Programming.',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the Java development industry and get a Backend Knowledge.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-59',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-Beginner',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'59 lessons • 7 projects • 8 quizzes',

        topics: [
            {
              id: 1,
              name: 'Lesson-1 Introduction',
              content: [
                'About Java Platforms',
                'Applications of Java',
                'About API (Application Programming Interface)',
                'Static Blocks',
                'Introduction to interfaces',
                'Runtime Polymorphism'
              ]
            },
            {
              id: 2,
              name: 'Lesson-2 Persistence',
              content: [
                'What is Persistence?File management system',
                'Disadvantages of File management system',
                'Database management system',
                'Advantages of Database management system'
              ]
            },
            {
              id: 3,
              name: 'Lesson-3 JDBC',
              content: [
                'Introduction to JDBC',
                'Why JDBC? & ODBC Vs JDBC',
                ' Approch-1 Vendor specific library',
                'Disadvantages',
                'Approch-2 X/Open standards',
                'Disadvantages',
                'Approch-3 ODBC standards',
                'Disadvantages',
                'Approch-4 JDBC standards',
                'Advantages',
              ]
            },
            {
              id: 4,
              name: 'Lesson-4 JDBC API and JDBC Drivers',
              content: [
                'About JDBC API',
                'What is a JDBC Driver?',
                'JDBC architecture',
                'Types of JDBC Drivers',
                'JDBC-ODBC bridge driver',
                'Advantages & Disadvantages',
                'Native API Partly Java Driver',
                'Advantages & Disadvantages',
                'Net-Protocol all/pure java driver',
                'Advantages & Disadvantages',
                'Native-Protocol pure java driver',
                'Advantages'
              ]
            },
            {
              id: 5,
              name: 'Lesson-5 JDBC API',
              content: [
                'JDBC Packages',
                'sql, Javax.sql',
                'Interfaces and classes in above packages',
                'Versions of JDBC API',
                'Steps for developing JDBC application'
              ]
            },
            {
              id: 6,
              name: 'Lesson-6 Introduction to SQL',
              content: [
                'Types of SQL queries'
              ]
            },
            {
              id: 7,
              name: 'Lesson-7 Establishing Connection to Database',
              content: [
                'About DriverManager class',
                'Methods of DriverManager',
                'What is registering driver with DriverManager',
                'Different methods of registering driver with DriverManager',
                'About getConnection method of DriverManager',
                'Syntax of URL to communicate with database',
                'Autoloading of class driver in JDBC 4.0',
                'Example with Application',
              ]
            },
            {
              id: 8,
              name: 'Lesson-8 Introduction',
              content: [
                'About DriverManager class',
                'Methods of DriverManager',
                'What is registering driver with DriverManager',
                'Different methods of registering driver with DriverManager',
                'About getConnection method of DriverManager',
                'Syntax of URL to communicate with database',
                'Autoloading of class driver in JDBC 4.0',
                'Example with Application',
              ]
            },
            {
              id: 9,
              name: 'Lesson-9 Statement interface',
              content: [
                'What is Statement? & Need of Statement',
                'Characteristics of Statement',
                'How to get Statement object?',
                'Methods of Statement',
                'Passing SQL statements to Database',
                'About execute, executeUpdate, executeQuery, largeExecute Updates methods',
                'Example with Application',
              ]
            },
      
            {
              id: 10,
              name: 'Lesson-10 PreparedStatement interface',
              content: [
                'What is PreparedStatement?',
                'Need of PreparedStatement',
                'Difference between Statement and PreparedStatement',
                'How to get PreparedStaement object',
                'Defining parameters',
                'How to pass values to PerparedStatement object',
                'What is SQL Injection attack & how to overcome',
                'Example with Application',
              ]
            },
      
            {
              id: 11,
              name: 'Lesson-11 Resultset Interface',
              content: [
                'What is ResultSet?',
                'Need of ResultSet',
                'How to get resultset object',
                'Methods of ResultSet',
                'Reading data, Various types of ResultSet',
                'Resultset types',
                'TYPE_SCROLL_SENSITIVE',
                'TYPE_SCROLL_INSENSITIVETYPE_FORWARD_ONLY',
                'Resultset modes',
                'CONCUR_READ_ONLY, CONCUR_UPDATABLE',
                'Example with Application'
              ]
            },
            {
              id: 12,
              name: 'Lesson-12 SQL 99 Datatypes',
              content: [
                'BLOB',
                'Inserting blob type, Reading blob type',
                'CLOB',
                'Inserting clob type, Reading clob type',
                'Array, Inserting array type',
                'Reading array type',
                'Object, Inserting object',
                'Reading object',
                'Example with Application',
              ]
            },
            {
              id: 13,
              name: 'Lesson-13 Metadata',
              content: [
                'Resultset Metadata',
                'Need of ResultsetMetaData',
                'How to get metadata',
                'DatabaseMetadata',
                'How to get database metadata',
                'Parameterizedmetadata',
                'How to get parameterizedmetadata',
                'Example with Application',
              ]
            },
            {
              id: 14,
              name: 'Lesson-14 CallableStatement',
              content: [
                'About CallableStatement',
                'Advantage of CallableStatement',
                'Creating CallableStatement object',
                'Calling Procedure using CallableStatement',
                'Calling functions using Callable Statement',
                'About PL/SQL Programming vs Manual on Batch Queries',
              ]
            },
            {
              id: 15,
              name: 'Lesson-15 Batch updates',
              content: [
                'What is batch processing',
                'Batch updates using Statement object',
                'Batch updates using PreparedStatement object',
              ]
            },
            {
              id: 16,
              name: 'Lesson-16 Transaction Management',
              content: [
                'Transaction Definition',
                'ACID Properties',
                'Atomicity, Consistency,Isolation, Durability',
                'Methods in Transaction Management',
                'setAutoCommit(), setSavePoint()',
                'commit(), rollback()',
                'Example with All Application',
              ]
            },
            {
              id: 17,
              name: 'Lesson-17 Connection Pooling',
              content: [
                'What is connection pooling?',
                'Advantages of connection pooling',
                'Disadvantage of DriverManager',
                'About DataSource',
                'JDBC connection pooling',
                'Isolation Levels',
                'Example with Application',
              ]
            },
            {
              id: 18,
              name: 'Lesson-18 RowSet',
              content: [
                'What is RowSet?',
                'What is difference between ResultSet and RowSet',
                'Types of RowSets',
                'JdbcRowSet',
                'CachedRowSet',
                'WebRowSet',
                'Example with Application',
              ]
      
            },
            {
              id: 19,
              name: 'Lesson-19 Communicating with different databases',
              content: [
                'Communicating with MYSQL',
                'Working with CSV files',
                'Communicating with MS-EXCEL',
                'Communicating with PostgreSql',
                'Example with Application',
              ]
            },
            {
              id: 20,
              name: 'Lesson-20 JDBC 4.0 Features',
              content: [
                'Auto-loading of JDBC driver class',
                'Connection management enhancements',
                'Support for RowIdSQL type',
                'DataSet implementation of SQL using AnnotationsSQL exception handling enhancements',
                'SQL XML support',
                'Example with Application',
              ]
            },
            {
              id: 21,
              name: 'Lesson-21 Working With Properties File',
              content: [
                'Working With Date Values',
                'Procedure To Create Desktop icon (jar file execution)',
              ]
            },
            {
              id: 22,
              name: 'Lesson-22 JEE',
              content: [
                'JEE technology',
                'Components of JEE technology',
                'What is Enterprises Application',
                'What is Web Application',
                'Types of Web Application',
                'Presentation Oriented Web Application',
                'Service Oriented Web Application',
                'About Web Client, About WebServer',
                'About ApplicationServer',
                'Diff Between WebServer And Application Server',
              ]
            },
            {
              id: 23,
              name: 'Lesson-23 Introduction',
              content: [
                'Server side technologies',
                'Need of server side technologies',
                'Client side technologies',
                'What is Servlet? & Advantages of Servlet',
                'Difference between CGI and Servlet',
              ]
            },
            {
              id: 24,
              name: 'Lesson-24 Servlet API',
              content: [
                'Versions of Servlet API',
                'Packages of Servlet API',
                'About Servlet Container',
                'Responsibilities of Servlet Container',
              ]
            },
            {
              id: 25,
              name: 'Lesson-25 HTTP Protocol',
              content: [
                'What is HTTP?',
                'What is HTTP Request format & Response format',
                'What is HTTP Request format & Response format'
              ]
            },
            {
              id: 26,
              name: 'Lesson-26 Developing Servlet',
              content: [
                'Servlet interface',
                'Methods of Servlet interface',
                'Developing servlet by implementing Servlet interface',
                'Life cycle methods of Servlet',
                'Web Application directory structure',
                'Deployment descriptor file (web.xml)',
                'What is deployment?',
                'Types of deployments',
                'Deployment, Console deployment',
                'Tool deployment',
                'Deployment web application in tomcat server',
                'URL patterns'
              ]
            },
            {
              id: 27,
              name: 'Lesson-27 Developing And Deploying Servlet Apps in Diff Servers Like',
              content: [
                'Tomcat Server',
                'JBoss Server / WildFly',
                'Weblogic Server',
                ' GlassFish',
                'ServletRequest',
                'Methods of ServletRequest',
                'About request parameters',
                'About request headers',
                'ServletResponse',
                'Methods of ServletResponse',
                'MIME types',
                'Generating response',
                'ServletConfig',
                'What is ServletConfig?',
                'What is need of ServletConfig',
                'Methods of ServletConfig',
                'Different ways of getting ServletConfig objects.',
                'Defining config initial parameters in web.xml',
                'GenericServlet',
                'What is GenericServlet?',
                'Methods of GenericServlet',
                'About init(ServletConfig),init() method',
                'Working with welcome-file',
                'Configuring welcome-file in web.xml',
                'Methods of loading Servlet',
                'About load on startup',
                'When client send first requestServletContext',
                'What is ServletContext?, Need of ServletContext',
                'Methods of ServletContext',
                'Different ways of getting ServletContext object',
                'Context init parameters',
                'Defining Context init parameters in web.xml',
              ]
            },
            {
              id: 28,
              name: 'Lesson-28 HttpServlet',
              content: [
                'What is HttpServlet?',
                'Methods of HttpServlet',
                'HTTP Request methods',
                'About public service and protected service methods',
                'About doXXX() methods',
                'Difference between GenericServlet and HttpServlet',
                'Diff Between doGet(-,-) and doPost(-,-) methods',
              ]
            },
            {
              id: 29,
              name: 'Lesson-29 HttpServletRequest',
              content: [
                'HttpServletRequest VS ServletRequest',
                'How to read request parameters of HttpServletRequest',
                'How to read request headers of HttpServletRequest',
              ]
            },
            {
              id: 30,
              name: 'Lesson-30 HttpServletResponse',
              content: [
                'HttpServletResponse VS ServletResponse',
                'About HttpServletResponse methods',
                'Response status codes',
              ]
            },
            {
              id: 31,
              name: 'Lesson-31 Redirecting',
              content: [
                'About sendRedirect method',
                'Difference between sendRedirect and forward methods',
                'setStatus, response.setHeader methods',
              ]
            },
            {
              id: 32,
              name: 'Lesson-32 Attributes',
              content: [
                'What is Attribute',
                'Difference between parameter and attribute',
                'Scope of Attributes',
                ' Request scope, Context scope',
                'Session scope',
                'Adding, removing and modifying attributes',
              ]
            },
            {
              id: 33,
              name: 'Lesson-33 State and Session Management',
              content: [
                'About connectionless protocol',
                'About connection oriented protocol',
                'Stateless protocol',
                'What is state/session management',
                'Need of session management',
                'Session management methods',
              ]
            },
            {
              id: 34,
              name: 'Lesson-34 URL rewriting, Hidden form fields',
              content: [
                'Cookies, HttpSession',
                'URL Rewriting',
                'What is URL rewritingURL rewriting techniques',
                'Disadvantages of URL rewriting',
              ]
            },
            {
              id: 35,
              name: 'Lesson-35 Hidden form fields',
              content: [
                'What is hidden form fields',
                'Disadvantages of hidden form fields',
              ]
            },
            {
              id: 36,
              name: 'Lesson-36 Cookies',
              content: [
                'What is Cookie,',
                'How to create Cookie',
                'Methods of Cookie',
                'Types of Cookies',
                'Non Persistent Cookie',
                'Persistent Cookie',
                'How to add cookie to response',
                'How to read cookie from request',
                'Deleting cookie from servlet',
                'Properties of Cookie',
                'Disadvantages of Cookies',
              ]
            },
            {
              id: 37,
              name: 'Lesson-37 HttpSession',
              content: [
                'What is HttpSession',
                'Advantage of HttpSession',
                'How to create HttpSession object',
                'How to read HttpSession object from request',
                'Invalidating HttpSession',
                'Using invalidate method',
                'Using session config in web.xml',
                'By setting time',
                'HttpSession attribute'
              ]
            },
            {
              id: 38,
              name: 'Lesson-38 Error Handling in Servlet',
              content: [
                'Configuring in web.xml'
      
              ]
            },
            {
              id: 39,
              name: 'Lesson-39 Filters',
              content: [
                'What is Filter?',
                'Need of Filter & Lifecycle of Filter',
                'Filter mapping in web.xmlAbout FilterConfig',
                'Defining config parameters in web.xml',
                'About FilterChain interface',
                'Methods of FilterChain',
                'What is Filter chaining?',
                'Working with filter chaining',
              ]
            },
            {
              id: 40,
              name: 'Lesson-40 Listeners',
              content: [
                'What is Listener?',
                'Usage of Listener',
                'About Event Delegation Model Architecture',
                'Types of Listeners',
                'RequestListener',
                'ServletContextListener',
                'HttpSessionListener',
                'Types of Attribute Listener',
                'Request AttributeListener',
                'HttpSessionAttributeListener',
                'ServletContextAttributeListener',
                'About Event classes',
              ]
            },
            {
              id: 41,
              name: 'Lesson-41 Authentication and Authorization(Security In Servlet Programming)',
              content: [
                'Understanding Authentication Mechanism',
                'HTTP basic authentication',
                'HTTP Digest authentication',
                'HTTPS Client authentication',
                'HTTP form based authentication'
              ]
            },
            {
              id: 42,
              name: 'Lesson-42 Working Connection Pooling',
              content: [
                'Connection pooling in difference servers',
                'Tomcat, Weblogic, Glassfish',
                'JBoss Server / WildFly',
                'Developing servlet using server side connection pooling'
              ]
            },
            {
              id: 43,
              name: 'Lesson-43 Working with domains',
              content: [
                'Creating domain in weblogic server',
                'Deploying web application using console',
                'Creating domain in glassfish server',
                'Deploying web application using console'
              ]
            },
            {
              id: 44,
              name: 'Lesson-44 Working with Servlet 2.5/3.0/3.1 features',
              content: [
                'Async Servlet',
                'File Uploading and Downloading',
                'Non-blocking I/O',
                'HTTP protocol upgrade mechanism',
                'Different Types Of URL Patterns',
                'Dynamic Registration Of Servlet (Developing Servlet Program Without web.xml)'
              ]
            },
            {
              id: 45,
              name: 'Lesson-45 Annotations in Servlet Programming',
              content: [
                'Introduction to Annotations',
                'Types of Annotations',
                'Annotations Vs web.xml',
              ]
            },
            {
              id: 46,
              name: 'Lesson-46 JSP Introduction',
              content: [
                'What is JSP?',
                'Advantages of JSP & Applications of JSP',
                'Difference between JSP & Servlet',
              ]
            },
            {
              id: 47,
              name: 'Lesson-47 JSP Basics',
              content: [
                'JSP Life cycle, JSP Lifecycle methods',
                'jspInit, _jspService',
                'jspDestroy, Saving jsp file as a',
                'Public resource, Private resouse',
              ]
            },
            {
              id: 48,
              name: 'Lesson-48 JSP tags',
              content: [
                'JSP Tags',
                'three categories of tags',
                'scripting elements, directives',
                'standard actions'
              ]
            },
            {
              id: 49,
              name: 'Lesson-49 Scripting Elements',
              content: [
                'What is scripting elements',
                'types of scripting elements',
                'Declaration tag',
                'Expression tag',
                'Scriptlet',
              ]
            },
            {
              id: 50,
              name: 'Lesson-50 JSP implicit object',
              content: [
                'What is jsp implicit objects',
                'Need of jsp implicit objects',
                'Implicit objects of jsp',
                'Request, Response, Page',
                'pageContext, out, session',
                'exception, application, config',
              ]
            },
            {
              id: 51,
              name: 'Lesson-51 Directives',
              content: [
                'What is directive?',
                'Types of directives',
                'Page directive, Include directive',
                'Taglib directive',
                'Standard Actions',
                'What is standard action',
              ]
            },
            {
              id: 52,
              name: 'Lesson-52 Standard actions',
              content: [
                '<jsp:include>',
                '<jsp:forward>',
                '<jsp:param>',
                '<jsp:useBean>',
                '<jsp:setProperty>',
                '<jsp:getProperty>',
                'Working with <jsp:include>',
                'Difference between <jsp:include> and <%@include> directive',
                'Working with <jsp:forward></jsp:forward>',
              ]
            },
      
            {
              id: 53,
              name: 'Lesson-53 Java Bean',
              content: [
                'What is java bean?',
                'Usage of bean',
                'Properties of bean',
              ]
            },
            {
              id: 54,
              name: 'Lesson-54 Using Java Bean in JSP',
              content: [
                'About <jsp:useBean>',
                'Attributes of <jsp:useBean>',
                'Working with scope of bean object',
                'Using bean with <jsp:include> and <jsp:forward>',
                'Assigning values to bean using <jsp:setProperty>',
                'Reading values from bean using <jsp:getProperty></jsp:getProperty>',
              ]
            },
            {
              id: 55,
              name: 'Lesson-55 Expression Language',
              content: [
                'What is Expression Language',
                'Advantage of Expression Language',
                'Syntax of defining expression',
                'Basic Operators in EL',
                ' Implicit objects In EL',
                ' pageScope, requestScope',
                'sessionScope, applicationScope',
                'param, paramValues, header',
                'headerValues, initParam, cookie',
                'pageContext, Defining functions',
              ]
            },
            {
              id: 56,
              name: 'Lesson-56 Working JSTL',
              content: [
                'What is JSTL?, Version of JSTL',
                'Classification of JSTL tags',
                'Core tags, Formatting tags',
                'SQL Tags, XML tags',
                'JSTL Functions',
                'How to use JSTL in web application',
                'Working with Core tags, Formatting tags & SQL tags',
                'Working JSTL functions',
              ]
            },
            {
              id: 57,
              name: 'Lesson-57 Custom Tags',
              content: [
                'What is tag?, Java based tag',
                'Components of tag library',
                'The Tag Handler Class',
                'The Tag Library Descriptor File',
                'Imports a tag library (referencing URL of descriptor file)',
                'Defines tag prefix',
                'Uses tags, About tag handler',
                'Tag interface, SimpleTag',
                'TagSupport, BodyTagSupport',
                'SimpleTagSupport',
                'Developing tag using SimpleTagSupport class',
                'Lifecycle of custom tag',
                'Tag handler class with attributes',
                'Developing tag with body',
              ]
            },
            {
              id: 58,
              name: 'Lesson-58 MVC Architecture',
              content: [
                'MVC Design patternMVC-1 Page Centric',
                'Advantages & Disadvantages',
                'MVC-2'
              ]
            },
            {
              id: 59,
              name: 'Lesson-59 Developing Project using MVC',
              content: [
                'Integrating JDBC , Servlets And JSP'
              ]
            },
      
          ]
    },
    {
        id:4,
        image: image5,
            title: "PHP Online Course",
            para: "Ratting: 4.2 ★ (7,508 reviews)|95%",
            paragraph1: "PHP is a server scripting language, and a powerful tool for making dynamic and interactive Web pages.PHP is a widely-used, free, and efficient alternative to competitors such as Microsoft's ASP. ",
            paragraph2: " PHP is a popular server-side scripting language for creating dynamic websites and web applications. PHP is a server-side scripting language that is embedded in HTML. PHP is a cross-platform language, capable of running on all major operating system platforms and with most of the web server programs such as Apache, IIS, lighttpd and nginx.",
      

        name:'PHP online course',
        description:'The objective of the Complete PHP Programming course is to provide participants with a thorough understanding of PHP programming language.   ',
        heading:'About this course',
        deshead:' To learn this Certified Blockchain Trainer Course for your professional journey .The following  tutorial explains the basic and advanced concepts of Blockchain Trainer and provides a firm foundation in the language that will enable you to begin developing your own projects and expanding on your knowledge. ',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Getting a complete knowledge in PHP and backend process.',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the PHP and backend development industry.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-11',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-intermediate',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'11 lessons • 5 projects • 8 quizzes',

        topics: [
            {
              id: 1,
              name: "Lesson-1 Creating, Managing and Mastering MySQL - MySQL Database",
              content: [
                'Installing and Configuring MySQL',
                'Understanding MySQL',
                'Creating and Managing Database',
                'MySQL data types',
                'Creating Tables and Managing Tables',
                'Data Manipulation in Tables – Insert, Update, Delete',
                'Querying Data from Tables – Select, Joins',
                'Advanced Data Manipulation – Groups, Functions, Constraints, Index',
                'Handling Transactions in MySQL'
              ]
            },
            {
              id: 2,
              name: 'Lesson-2 Developing Web Applications using PHP - Introduction to PHP',
              content: [
                'What is PHP',
                'The Power of PHP',
                'Learning the history of PHP',
                'Javascript / Jquery Vs PHP',
                'What is Server Side Scripting',
                'Client Side Scripting Vs Server Side Scripting',
                'Installation of XAMPP',
                'Importance of Apache Server',
                'Configuring PHP and setting up the Environment',
                'Working with Editors',
              ]
            },
            {
              id: 3,
              name: 'Lesson-3 Basics of PHP',
              content: [
                'Coding PHP in HTML Document',
                'Embedding PHP Codes',
                'Executing PHP Embedded HTML Documents',
                'PHP Coding Structure',
                'Variables in PHP',
                'Data types in PHP – Number, Strings, Date, NULL',
                'Arrays and Variations of Arrays'
              ]
            },
            {
              id: 4,
              name: 'Lesson-4 Control Structures of PHP',
              content: [
                'Decision Making with IF Statements​',
                'Variations of IF Statements',
                'Switch Statements',
                'Using Operators with Decision Making Structures',
                'Looping Structures',
                'While Loops, For Loops, Foreach Loops',
                'Using CONTINUE and BREAK in Loops',
                'Managing Arrays with Control Structures',
              ]
            },
            {
              id: 5,
              name: 'Lesson-5 Functions in PHP',
              content: [
                'Understanding Functions in PHP',
                'Using Built-in Functions – Date, String and Mathematical Functions',
                'Handling Return Value',
                'Nesting Functions',
              ]
            },
            {
              id: 6,
              name: 'Lesson-6 User Defined Functions in PHP',
              content: [
                'Defining our Own Functions',
                'Understanding Arguments and Return Values',
                'Scope of Functions',
                'Handling Multiple return values',
                'Defining default Arguments',
              ]
            },
            {
              id: 7,
              name: 'Lesson-7 File Handling in PHP',
              content: [
                'Basics of File Handling and need to handle Files from PHP',
                'Creating a File using PHP',
                'Reading, Writing, Appending Files',
                'Copy and Rename Files',
                'Delete Files',
                'Working with Directories',
                'Parsing Directory Structures',
                'Uploading Files',
              ]
            },
            {
              id: 8,
              name: 'Lesson-8 Handling FORMS in PHP',
              content: [
                'Understanding PHP Forms',
                'Validating User Inputs',
                'Displaying Messages for Validation Errors',
                'Using Functions for Validations',
                'Creating Custom Functions for Data Validation',
                'Handling Form Submissions',
                'Handling Exceptions',
              ]
            },
            {
              id: 9,
              name: 'Lesson-9 Accessing MySQL with PHP',
              content: [
                'Introduction to Database APIs',
                'Establishing Connection with Databases',
                'Retrieving data from Database',
                'Manipulating Retrieved Data',
                'Updating Records in Database using PHP',
                'Deleting Records in Database using PHP',
                'Understanding SQL Injection',
              ]
            },
            {
              id: 10,
              name: 'Lesson-10 Sessions and Cookies',
              content: [
                'Understanding Cookies',
                'Purpose and use of Cookies',
                'Setting and Reading Cookie Values',
                'Resetting Cookie Values',
                'Understanding Sessions and importance of Sessions',
                'Starting a Session and Working with Session',
                'Understanding Session Variables',
                'Closing Sessions',
              ]
            },
            {
              id: 11,
              name: 'Lesson-11 Using Emails for Form Submission in PHP',
              content: [
                'Email Configuration in PHP',
                'Need for Sending Mails from Web Applications',
                'Using Sendmail',
                'Using PHPMailer',
              ]
            },
          ]
    },
    {
        id:5,
        image: image6,
            title: "Flutter Online Course",
            para: "Ratting: 4.1 ★ (7,508 reviews)|95%",
            paragraph1: "Flutter is Google’s Mobile SDK to build native iOS and Android, Desktop (Windows, Linux, macOS), and Web apps from a single codebase.Hot Reloading refers to the injection of new versions of the files that you edited at runtime while keeping the app running.",
            paragraph2: "The Apps developed using Flutter are highly expressive and have flexible UI.Flutter lets developers build beautiful-looking apps with ease by using prebuild material widgets.",
       

        name:'Flutter online course',
        description:'This course is eligible for App Developer to become Flutter developer. ',
        heading:'About this course',
        deshead:' To learn this Certified Flutter online Course for your professional journey .The following  tutorial explains the basic and advanced concepts of Flutter and provides a firm foundation in the language that will enable you to begin developing your own projects and expanding on your knowledge. ',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Getting a complete app development knowledge and flutter programming.',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the App development industry.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-17',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-intermediate',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'17 lessons • 14 projects • 8 quizzes',

        topics: [
            {
              id: 1,
              name: 'Introduction to Flutter',
              content: [
                'Importance of Flutter Introduction to Dart Writing Dart Code',
                'DartPad',
                'Installing Dart SDK',
                'IntelliJ IDEA',
                'Installing IntelliJ IDEA',
                'Creating a Dart Project Using IntelliJ IDEA',
                'Using DartPad',
              ]
            },
            {
              id: 2,
              name: 'Introduction To Dart',
              content: [
                'Intro to Dart',
                'Installing Visual Studio Code and the Dart Plugin',
                'Installing Dart SDK',
                'Writing the first Dart Program',
              ]
            },
            {
              id: 3,
              name: 'Dart Functions',
              content: [
                'Dart Functions',
                'Function Structure',
                'Creating a Function',
                'Function Return Data Types',
                'Void Function',
                'Function Returning Expression',
                'Functions and Variable Scope',
                'Object-Oriented Programming (OOP)',
                'Object',
                'Class',
                'Creating a Class',
                'Adding Methods to Classes',
                'Providing Constructors for Your Classes',
                'Class and Class Inheritance',
                'Abstract Class',
              ]
            },
            {
              id: 4,
              name: 'First Flutter App',
              content: [
                'Building an App From Scratch',
                'Running The App on Emulator',
                'Class Constructors & Named Arguments',
                'Deep Dive Basics Into Flutter App',
                'Building a Widget Tree',
                'Visible & Invisible Widgets',
                'Adding Layout Widgets',
              ]
            },
            {
              id: 5,
              name: 'Flutter Framework',
              content: [
                'Flutter Framework',
                'Android Studio',
                'Android Studio Software Prerequisite',
                'Installing Android Studio',
                'Flutter SDK',
                'Installing and Configuring Flutter SDK',
                'Creating a New Flutter Project',
                'Setup an Android Virtual Device',
                'Run a Flutter App',
                'Installing Flutter on Mac',
                'Test Your Flutter App on iOS Phone with Windows O.S',
                'Android Studio Sugar and Spice',
                'Run your Apps on a Hardware Device',
                'Run your Flutter App on Android Phone',
                'Emulator Debug Mode',
                'Introduction to Flutter Widgets',
                'Creating a Flutter App Using Widgets',
                'MaterialApp Widgets',
              ]
            },
            {
              id: 6,
              name: 'Flutter Widgets',
              content: [
                'Scaffold Widget',
                'Image Widget',
                'Container Widget',
                'Column and Row Widgets',
                'Icon Widget',
                'Layouts in Flutter',
                'Card Widget',
                'App Icons for iOS and Android Apps',
                'Hot Reload and Hot Restart',
                'Stateful and Stateless Widgets',
                'Use a Custom Font'
              ]
            },
            {
              id: 7,
              name: 'Navigation & Routing',
              content: [
                'Button Widget',
                'FloatingActionButton',
                'RaisedButton, FlatButton, and IconButton',
                'DropdownButton & OutlineButton',
                'ButtonBar',
                'PopupMenuButton',
                'App Structure and Navigation',
                'Navigate to a New Screen and Back',
                'Navigate with Named Routes',
                'Send and Return Data Among Screens',
                'Animate a Widget Across Screens',
                'WebView Widget in Flutter',
              ]
            },
            {
              id: 8,
              name: 'Widgets Implementation',
              content: [
                'Introduction',
                'BottomNavigatorBar Widget',
                'DefaultTabController, TabBar, and TabBarView Widgets',
                'ListTile Widget, ListView Widget, Drawer Widget, DataTable Widget, SelectableText Widget and Stack Widget',
                'Input and Selections',
                'Text Field Widget',
                'Checkbox Group and RadioButtonGroup Widgets',
                'Date Picker & Time Picker',
                'Slider Widget & Switch Widget',
                'Dialogs, Alerts, and Panels',
                'Alert Dialog Widget',
                'Cupertino Alert Dialog Widget',
                'Bottom Sheet, Modal Bottom Sheet & Persistent Bottom Sheet',
                'Expansion Panel Widget & Snack Bar Widget'
              ]
            },
            {
              id: 9,
              name: 'Firebase',
              content: [
                'Introduction',
                'JSON',
                'Firebase Database',
                'Firebase Authentication',
                'Configure Your App to use Firebase Services',
                'Adding Firebase to your Android App',
                'Adding Firebase to your iOS App',
                'Configuring Firebase Authentication',
                'Login to an App Using Firebase User Accounts',
                'Logout Configuration',
                'Firebase Database',
                'Real Time Database',
                'Cloud Firestore',
              ]
            },
            {
              id: 10,
              name: 'Location Aware Apps',
              content: [
                'Introduction',
                'GPS',
                'Camera Position',
                'Adding Google Maps to a Flutter app',
                'Getting a Google API key',
                'Adding Google Maps Flutter plug-in as a dependency',
                'Adding your API key for your Android app',
                'Adding your API key for your iOS app',
                'Adding a Google Map on Your Flutter App Screen',
                'Adding a Google Map Marker',
                'Google Map Types',
                'Camera Animation',
                'Capturing an App User’s Location for iOS and Android Apps',
                'Getting a Google API key',
                'Creating an App Interface',
                'Configuring your App to Use Your API Key',
                'Adding a Google Map on your Flutter App Screen',
                'Adding a Google Map Marker',
                'Flutter TM Application Development',
                'Capturing Users’ Location',
                'Configuring User App’s Permission'
              ]
            },
            {
              id: 11,
              name: 'User Interface',
              content: [
                'Applying Theme Data',
                'The Basic Screen Layout',
                'Applying Custom Font',
              ]
            },
            {
              id: 12,
              name: 'Asynchronous Functions',
              content: [
                'Function',
                'Async and Await'
              ]
            },
            {
              id: 13,
              name: 'Working With Remote Data',
              content: [
                'The ‘http’ Package',
                'Model Class and JSON Parsing',
                'Displaying Remote Data'
              ]
            },
            {
              id: 14,
              name: 'Using 3rd Party Packages',
              content: [
                'The ‘url_launcher’ Package',
                'Adding onTap() to NEWS API'
              ]
            },
            {
              id: 15,
              name: 'Other Useful Widgets',
              content: [
                "Grid View",
                "The ‘Hero’ Animation",
                "Stack",
                "‘Alert Dialog’ with Buttons"
              ]
            },
            {
              id: 16,
              name: 'User Interface',
              content: [
                'Applying Theme Data',
                'The Basic Screen Layout',
                'Applying Custom Font'
              ]
            },
            {
              id: 17,
              name: 'Publishing and App Testing',
              content: [
                'Testing and Feedback for Your App',
                'Setting up a Test Environment',
                'Usability Testing by Participants',
                'Starting your Test Session',
                'Analyzing your Test',
                'Publishing Flutter Apps',
                'Publishing Android App on Google Play Store',
                'Publishing iOS app on Apple Store'
              ]
            }
          ]
    },
    {
        id:6,
        image: image7,
        title: "MYSQL Database Management",
        para: "Ratting: 4.1 ★ (7,508 reviews)|95%",
        paragraph1: "MySQL is a widely used relational database management system (RDBMS). MySQL is free and open-source. MySQL is ideal for both small and large applications.MySQL is a very popular open-source relational database management system (RDBMS).",
        paragraph2: "MySQL is a Relational Database Management System or RDBMS which means that it stores and presents data in tabular form, organized in rows and columns.MySQL has a unique storage engine architecture which makes it faster, cheaper, and more reliable.",
   

        name:'MYSQL Database Management',
        description:'This course is eligible Basic understanding in MYSQL to become Database administrator. ',
        heading:'About this course',
        deshead:' To learn this MySQL Course for your professional journey .The following  tutorial explains the basic and advanced concepts of MYSQL and provides a firm foundation in the language that will enable you to begin developing your own database and expanding on your knowledge. ',
        heading1:'Skills you will gain',

        desheading1:[
            '⍟ Getting a complete teaching knowledge and knowledge about MySQL programming.',
            '⍟ Learn essential skills.',
            '⍟ Familiarize yourself with the Mysql database administrator industry.',
        ],

         heroSec:[
            {
              id:1,
              symbol:'📝',
              content:'Lessons-09',
            },
            {
                id:2,
                symbol:'🕜',
                content:'Timing-9.30 to 1.30',
              },

            {
              id:3,
              symbol:'📅',
              content:'Months-3',
            },
            {
              id:4,
              symbol:'🎖',
              content:'Fee-15000',
            },
            {
              id:5,
              symbol:'⤴️',
              content:'Skill Level-intermediate',
            },
            {
              id:6,
              symbol:'🏅',
              content:'Certificate-Yes',
            },
            {
              id:7,
              symbol:'🗒 ',
              content:'Assessments-Yes',
            },
          ],
        syllabusheading:'Syllabus',
        syllabus:'12 lessons • 7 projects • 8 quizzes',

        topics:  [

            {
                id: 1,
                name: 'Lesson 1: Introduction to MySQL  ',
                content: [
                    'What is MySQL?',
                    'What is the uses of MySQL?',
                    'Who uses MySQL?',
                    'Why we Use?',
        
                ]
            },
            {
                id: 2,
                name: 'Lesson 2:MySQL RDBMS ',
                content: [
                    'What is RDBMS?',
                    'What is a Database Table?',
                    'What is a Relational Database?',
        
                ]
            },
            {
                id: 3,
                name: 'Lesson 3: MySQL SQL',
                content: [
                    'What is SQL?',
                    'How to Use SQL?',
                    'Some of The Most Important SQL Commands',
        
        
                ]
            },
            {
                id: 4,
                name: 'Lesson 4: MySQL SELECT Statement ',
                content: [
                    'The MySQL SELECT Statement',
                    'Demo Database',
                    'SELECT * Example',
                    'The MySQL SELECT DISTINCT Statement',
                    'SELECT Example Without DISTINCT',
                    'SELECT DISTINCT Examples',
                    
        
        
                ]
            },
            {
                id: 5,
                name: 'Lesson 5: MySQL WHERE Clause',
                content: [
                    'The MySQL WHERE Clause',
                    'Demo Database',
                ]
            },
            {
                id: 6,
                name: 'Lesson 6: MySQL AND, OR and NOT Operators',
                content: [
                    'The MySQL AND, OR and NOT Operators',
                    'Demo Database',

                ]
            },
            {
                id: 7,
                name: 'Lesson 7: MySQL ORDER BY Keyword',
                
                content: [
                   'Demo Database',
                   'ORDER BY Several Columns Example'
                ]
            },
            {
                id: 8,
                name: 'Lesson 7: MySQL Comments  ',
                content: [
                   'MySQL INSERT INTO Statement',
                   'MySQL NULL Values',
                   'MySQL UPDATE Statement',
                   'MySQL DELETE Statement',
                   'MySQL LIMIT Clause ',
                ]
            },
            {
                id: 7,
                name: 'Lesson 7: MySQL Joins',
                content: [
                   'MySQL INNER JOIN Keyword',
                   'MySQL OUTER JOIN Keyword',
                   'MySQL LEFT JOIN Keyword',
                   'MySQL RIGHT JOIN Keyword',
                   'MySQL CROSS JOIN Keyword',
                ]
            },
            {
                id: 8,
                name: 'Lesson 8: MySQL GROUP BY Statement',
                content: [
                    'GROUP BY STATEMENT ',
                   'GROUP BY With JOIN Example',
                   
                ]
            },
            {
                id: 9,
                name: 'Lesson 9: MySQL Operators',
                content: [
                   'MySQL Arithmetic Operators',
                   'MySQL Comparison Operators',
                   'MySQL Compound Operators',
                   'MySQL Logical Operators',
                   ''
                ]
            },
            {
                id: 10,
                name: 'Lesson 10: MySQL Database',
                content: [
                    'MySQL CREATE DATABASE Statement',
                    'MySQL DROP DATABASE Statement',
                    'MySQL ALTER DATABASE Statement',
                    'MySQL DELETE DATABASE Statement',
                    'MySQL TRUNCATE DATABASE Statement'
                   
                ]
            },
            {
                id: 11,
                name: 'Lesson 10: CONSTRAINTS ',
                content: [
                   'Primary key',
                   'Unique',
                   'Foreign key',
                   'Check',
                   'Default',
                ]
            },
            {
                id: 12,
                name: 'Lesson 11: References',
                content: [
                  'Data Types',
                  'Functions',
                ]
            },
        
        
        
        
            
        
        ]
    },
];